import axios from "axios";
import logger from "./logService";
import { toast } from "react-toastify";

const tokenKey = "token";
const AuthorizationKey = "Authorization";

axios.interceptors.response.use(null, error => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  if (!expectedError) {
    logger.log(error);
    toast.error("An unexpected error occurrred.");
  }

  return Promise.reject(error);
});

export function setJwtfromLocalStorage() {
  const jwt = localStorage.getItem(tokenKey);
  axios.defaults.headers.common[AuthorizationKey] = "Bearer " + jwt;
}

export function setJwt(jwt) {
  axios.defaults.headers.common[AuthorizationKey] = "Bearer " + jwt;
}

export function getJwt() {
  return localStorage.getItem(tokenKey);
}

export function setBearerAuthorization(jwt) {
  axios.defaults.headers.common[AuthorizationKey] = "Bearer " + jwt;
}

export function addBearerAuthorization() {
  axios.defaults.headers.common[AuthorizationKey] = "Bearer " + getJwt();
}

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  patch: axios.patch,
  fetch: axios.fetch,
  setJwt,
  setJwtfromLocalStorage,
  addBearerAuthorization,
  setBearerAuthorization
};
